import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SearchStateService {
  
  //Guarda el estado de la busqueda en localStorage
  saveSearchState(state: any, key:string) {
    localStorage.setItem(key, JSON.stringify(state));
  }
  //Devuelve el estado de la busqueda del localStorage
  getSearchState(key:string) {
    return JSON.parse(localStorage.getItem(key));
  }
  //Limpia / borra el estado de la busqueda del localStorage
  clearSearchState(key: string) {
    localStorage.removeItem(key);
  }

  constructor() {}
}
